(function () {
    'use strict';

    angular.module("imApp").factory("acVatCodeDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3427,
                    parameters: parms || {}
                });
            },
            listVatTaxLevels: function (parms) {
                return $ihttp.post({
                    method: 3433,
                    parameters: parms || {}
                });
            },
            listVatReportGroups: function (parms) {
                return $ihttp.post({
                    method: 3434,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3428,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
